import { Component, Input, Output } from "@angular/core";
import { DodoBaseButtonComponent } from "../dodo-base-button/dodo-base-button.component";

@Component({
    selector: "dodo-cta-button",
    templateUrl: "./dodo-cta-button.component.html",
    styleUrls: ["./dodo-cta-button.component.scss"],
    standalone: false
})
export class DodoCtaButtonComponent extends DodoBaseButtonComponent {
	public toggle = false;
	@Input()
	title: string;

	@Input()
	titlePrefix: string;

	@Input()
	titleSuffix: string;

	@Input()
	subTitle: string;

	@Input()
	iconImage: string;

	@Input()
	image: string;

	@Input()
	active = false;

	@Input()
	uid = null;

	@Input()
	finePrints: string;

	@Input()
	hasFinePrints: boolean;

	@Input()
	width: number;

	@Input()
	titleMargin: boolean;

	@Input()
	tags: string[];

	@Input()
	isPurple = false;

	constructor() {
		super();
	}

	toggleState(event: Event) {
		event.stopPropagation();
		if (!this.disabled) {
			this.clicked.emit(this.uid);
		}
	}
}
